<template>
  <div width="100%">
    <Breadcrumb :title="'Program Report'"></Breadcrumb>

  <div class="row no-gutters">
    <div class="input-group mb-3 col-md-5 pl-0">
          <kendo-autocomplete
            id="SearchProgram"
            class="form-control"
            v-model="autoCompleteDisplayedValue"
            :data-source="programAutoCompleteSource"
            :data-text-field="'Title'"
            :filter="'contains'"
            :placeholder="'Search for Program'"
            @select="onAutoCompleteSelect"
          ></kendo-autocomplete>
          <div class="input-group-append">
            <span class="input-group-text">
              <i class="fa fa-search"></i>
            </span>
          </div>
        </div>

        <div class="form-group col-md-4">
              <div class="input-group">
                <kendo-datepicker
                  placeholder="Select Date"
                  :value='selectedDate'
                  v-model='selectedDate'
                  :format="'MM/dd/yyyy'"
                  id="dtAsOfDate"
                  @open="_setCurrentDateifNull">
                </kendo-datepicker>
              </div>
            </div>
  </div>


    <div class="row no-gutters">
      <!-- <ProgramForm :disabled="true" :ProgramInfo="ProgramInfo" :ProgramLabel="'Program Report'"></ProgramForm> -->
      <ProgramForm :disabled="true" :ProgramInfo="ProgramInfo" v-show="formDisplay"
      :ProgramGridGrouping="gridGrouping" :ProgramGridAggregate="gridAggregate"
      :PartnerData="ProgramPartners"
      ></ProgramForm>
    </div>

    <div>
      <p class="alert-danger" v-if="ProgramNewErrors">
        Please find the following errors :
        <br>
        {{ProgramNewErrors}}
      </p>
    </div>
    <!-- <button class="btn btn-primary mb-2 mt-2" @click="SaveProgramData" style="float:right; width:120px;">Update</button> -->
  </div>
</template>

<script>
import $ from "jquery";
import ProgramForm from "@/components/forms/ProgramForm.vue";
import _ from "lodash";
import moment from "moment";

import {
  PartnerUnitGridConfig,
  PartnerUnitToolbarConfig,
  ProgramInfoConfig
} from "./ProgramReportConfig.js";
import BaseGrid from "@/components/base/BaseGrid.vue";
import Breadcrumb from "@/components/layout/Breadcrumb.vue";
import BaseToolBar from "@/components/base/BaseToolbar.vue";
import toolbarUtility from "@/services/toolbarUtility.js";
import funcUtil from "@/services/funcUtil.js";
import apiUtil from "@/services/apiUtil.js";
import deepGroupBy from "@/services/groupByUtil.js";
import BaseModelProgram from "@/models/BaseModelProgram.js";
import BaseModelInvestment from "@/models/BaseModelInvestment.js";
import BaseModelUnitClass from "@/models/BaseModelUnitClass.js";
import BaseModelVestingSchedule from "@/models/BaseModelVestingSchedule.js";
import BaseModelPartner from "@/models/BaseModelPartner.js";
import BaseModelIssuance from "@/models/BaseModelIssuance.js"
import BaseModelTransfer from "@/models/BaseModelTransfer.js"
import BaseModelTransactionLog from "@/models/BaseModelTransactionLog.js";
import BaseModelDistribution from "@/models/BaseModelDistribution.js";
import BaseModelVesting from "@/models/BaseModelVesting.js";
import BaseModelAllocation from "@/models/BaseModelAllocation.js";
import BaseModelUnitRunningTotal from "@/models/BaseModelUnitRunningTotal.js";
import BaseInvestmentValuation from "@/models/BaseModelInvestmentValuation.js";

import { mapGetters, mapActions, mapState } from "vuex";
import { isNullOrUndefined } from "util";

import BuyoutMixin from "@/mixins/Buyout.js";
import VestingScheduleDatesMixin from "@/mixins/VestingScheduleDatesMixin.js";
import ProgramPartnerMixin from "@/mixins/ProgramPartnerMixin.js";
import PartnerInvestorMixin from "@/mixins/PartnerInvestorMixin.js";

export default {
  name: "ProgramReport",
  mixins: [toolbarUtility, apiUtil, funcUtil, ProgramPartnerMixin, PartnerInvestorMixin, BuyoutMixin, VestingScheduleDatesMixin, ],
  computed: {
    ...mapGetters("getModule", ["withFilter", "getJoinedItemsFilter"]),
    ...mapState("postModule", ["response"])
  },
  data: function() {
    return {
      ProgramNewErrors: "",
      PartnerUnitGridConfig,
      PartnerUnitToolbarConfig,
      dateValue: "01/01/2018",
      autocompleteValue: "",
      programAutoCompleteSource: [],
      programId: this.$route.params.programId,
      BaseModelProgram: BaseModelProgram,
      BaseModelInvestment: BaseModelInvestment,
      BaseModelUnitClass: BaseModelUnitClass,
      BaseModelVestingSchedule: BaseModelVestingSchedule,
      BaseModelPartner: BaseModelPartner,
      BaseModelTransactionLog : BaseModelTransactionLog,
      BaseModelDistribution: BaseModelDistribution,
      BaseModelAllocation: BaseModelAllocation,
      BaseModelVesting: BaseModelVesting,
      BaseModelUnitRunningTotal: BaseModelUnitRunningTotal,
      BaseInvestmentValuation: BaseInvestmentValuation,
      BaseModelIssuance: BaseModelIssuance,
      BaseModelProgram: BaseModelProgram,
      ProgramInfo: { parent: {}, children: {} },
      ProgramPartners: [],
      formDisplay: false,
      autoCompleteDisplayedValue: "",
      gridGrouping: {
        field: "PartnerTaxStatus",
        dir: "desc",
        aggregates: [
          { field: "StandardIssuance", aggregate: "sum" },
          { field: "StandardTransfer", aggregate: "sum" },
          { field: "StandardForfeiture", aggregate: "sum" },
          { field: "StandardTotal", aggregate: "sum" },
          { field: "SupplementalIssuance", aggregate: "sum" },
          { field: "SupplementalTransfer", aggregate: "sum" },
          { field: "SupplementalForfeiture", aggregate: "sum" },
          { field: "SupplementalTotal", aggregate: "sum" },
          { field: "TotalUnits", aggregate: "sum" },
          { field: "AdjustedTotalUnits", aggregate: "sum" },
          { field: "TaxOwnership", aggregate: "sum" },
          { field: "FMVOwnership", aggregate: "sum" }
        ]
      },
      gridAggregate: [
        { field: "StandardIssuance", aggregate: "sum" },
        { field: "StandardTransfer", aggregate: "sum" },
        { field: "StandardForfeiture", aggregate: "sum" },
        { field: "StandardTotal", aggregate: "sum" },
        { field: "SupplementalIssuance", aggregate: "sum" },
        { field: "SupplementalTransfer", aggregate: "sum" },
        { field: "SupplementalForfeiture", aggregate: "sum" },
        { field: "SupplementalTotal", aggregate: "sum" },
        { field: "TotalUnits", aggregate: "sum" },
        { field: "AdjustedTotalUnits", aggregate: "sum" },
        { field: "TaxOwnership", aggregate: "sum" },
        { field: "FMVOwnership", aggregate: "sum" }
      ],
      criteriaData: {
        ProgramType: "", //EUM  -- EPP
        Partner: {
          Id: "",
          text: ""
        }, // {Id: "7", text: "Partner 97"} -- {Id: "20", text: "Partner 34"}
        TaxPeriod: "", //2018 Q4
        PriorTaxPeriod: "" //2018 Q2
      },
      classRunningTotalDict:{},
      classRunningBonusUnits : {},
      bonusUnits : "",
      ExceptionProgram : {
        "Master" : {"Id" : 81,"ProgramID" : 30010, "InvestmentId" : 49,"InvestmentInvestmentId" : 500010},
        "Child" : {"Id" : 82,"ProgramID" : 30011, "InvestmentId" : 50,"InvestmentInvestmentId" : 500011}
      },
      selectedDate:null
    };
  },
  beforeRouteUpdate(to, from, next) {
    this.programId = to.params.programId;
    //this.getProgram();
    if (this.programId) {
      this.formDisplay = true;
      this.getProgramInformation();
    } else {
      this.autoCompleteDisplayedValue = "";
      this.formDisplay = false;
    }
    //this.$router.go(this.$router.currentRoute)

    next();
  },
  components: {
    ProgramForm,
    Breadcrumb
  },
  methods: {
    ...mapActions("postModule", [""]),

    SaveProgramData: function() {
      var bValid = this.Validate();
      if (bValid) {
        // send the added data to API
        console.log(JSON.stringify(this.ProgramInfo));
        alert("Program Updated successfully!");
        this.$router.push("/");
      }
    },
    onAutoCompleteSelect(e) {
      this.autocompleteValue = e.dataItem.Id;
      //this.programId = to.params.programId
      this.programId = e.dataItem.Id;
      //this.$router.push("/");
      this.$router.push({
        name: "ProgramReport",
        params: { programId: this.programId }
      });
      //this.getProgram();)
    },

    getProgramInformation() {
      this.classRunningTotalDict={};
      this.classRunningBonusUnits = {};
      this.bonusUnits = 0;
      if(this.selectedDate==null){
        this.selectedDate= new Date();
      }
      //By Deafult Summary View Should be Selected when Chnaging Programs.
      $("#summaryView")[0].checked = true;

      if (this.programId) {
        var self = this;
        let storeResponse = this.getJoinedItemsFilter({
          parentConfig: BaseModelProgram,
          parentId: this.programId,
          keyToJoin: "Program/Id",
          childConfigs: [
            BaseModelTransactionLog,
            BaseModelUnitClass,
            BaseModelVestingSchedule
          ]
        });

        let programId2 = this.programId;

        console.log("Program Data with Transaction Childern", storeResponse);
        let response = JSON.parse(JSON.stringify(storeResponse));
        response.selectedDate = self.selectedDate;
        this.ProgramInfo = response;
        //console.log(response)
        if (response.parent.StateSource) {
          this.ProgramInfo.parent.StateSource = response.parent.StateSource.split(
            ","
          );
        }
        if (response.parent.IncomeSource) {
          this.ProgramInfo.parent.IncomeSource = response.parent.IncomeSource.split(
            ","
          );
        }

        //var tranData = _.concat(response.children.Transfer,response.children.Forfeiture,response.children.Issuance);
        let tranData = _.filter(response.children.TransactionLog, function(o) { return moment(o.TransactionDate) <= moment(self.selectedDate) });
        // Add Exception Program, Two programs data into one
        let mergeTranData;
        if(this.programId == self.ExceptionProgram.Master.Id)
        {

          let filterQuery = {
            filter: "ProgramId eq " + self.ExceptionProgram.Child.Id
          };

          let resultMergeProgram = self.withFilter(
            self.BaseModelTransactionLog.list,
            filterQuery
          );

          if(resultMergeProgram.length) {
            mergeTranData = _.filter(resultMergeProgram, function(o) { return moment(o.TransactionDate) <= moment(self.selectedDate) });
            mergeTranData.forEach(function(item){
              item.ProgramId = self.ExceptionProgram.Master.Id;
              tranData.push(item);
            })
          }

        }

        //deepGroupByTest

        const getConfig1 = item => item.PartnerId;
        const getConfig2 = item => item.UnitClass;
        const getConfig3 = item => item.VestingType;
        const getConfig4 = item => item.UnitType;
        const getConfig5 = item => item.BusinessEvent;

        var groupByResult = deepGroupBy(
          tranData,
          getConfig1,
          getConfig2,
          getConfig3,
          getConfig4,
          getConfig5
        );
        console.log(groupByResult);
        var calculatedPartnerInfo = [];
        var taxRunningTotal = 0;
        var FMVRunningTotal = 0;

        //Bonus units deduction on the fly
        //self.calcBonusUnits(tranData);

        //Calculate transaction details for each partner from transaction records

        Object.keys(groupByResult).forEach(function(partnerkey, partnerindex) {
          let partnerResults2 = self.getPartnerProgramData(partnerkey, programId2);
          //let partnerResults2 = self.getPartnerProgramData(partner.Id, programId2);
          //console.log(result[key])
          // key: the name of the object key
          // index: the ordinal position of the key within the object
          let partnerResult = groupByResult[partnerkey];
          Object.keys(partnerResult).forEach(function(unitclasskey,unitclassindex) {
            let result=partnerResult[unitclasskey];
            Object.keys(result).forEach(function(key, index) {
              var partner = {};
              partner.Id = partnerkey;
              partner.PartnerID=null;
              partner.Name = "";
              partner.PartnerTaxStatus = "";
              partner.UnitClass = unitclasskey;
              partner.VestingType = key;
              partner.Ownership = 0;
              partner.TreasuryNew = "";
              partner.HireDate = "";
              partner.LeaveDate = "";
              partner.PartnerType = "";
              partner.StandardIssuance = 0;
              partner.StandardTransfer = 0;
              partner.StandardForfeiture = 0;
              partner.StandardTotal = 0;
              partner.SupplementalIssuance = 0;
              partner.SupplementalTransfer = 0;
              partner.SupplementalForfeiture = 0;
              partner.SupplementalTotal = 0;
              partner.TotalUnits = 0;
              partner.AdjustedTotalUnits = 0;
              partner.TaxOwnership = 0;
              partner.FMVOwnership = 0;

              partner.PreviousUnitDistribution = 0;
              partner.ProgProjectedValue = 0;
              partner.ProjectedUnrealizedValue = 0;
              partner.TotalPotentialPreTaxValuePercentChange = 0;
              partner.CurrentProgCurrentValueValue = 0;
              partner.CurrentValue = 0;
              partner.TotalCurrentPreTaxValuePercentChange = 0;
              


              //Issuance and Forfeiture dates
              partner.IssuanceDate = "";
              partner.ForfeitureDate = "";

              // var IssuanceData=result[key].Standard.Issuance

              //read Inside Standard and Supplemental
              var partnerBusinessEventData = result[key];

              //console.log(partnerBusinessEventData.Standard.Issuance)
              //Standard Calculation
              if (
                partnerBusinessEventData &&
                partnerBusinessEventData.Standard
              ) {
                if (partnerBusinessEventData.Standard.Issuance) {
                  let IssuanceArray =
                    partnerBusinessEventData.Standard.Issuance;
                  self.calcSum(
                    IssuanceArray,
                    "Unit",
                    partner,
                    "StandardIssuance"
                  );
                }
                if (partnerBusinessEventData.Standard.Transfer) {
                  let TransferArray =
                    partnerBusinessEventData.Standard.Transfer;
                  self.calcSum(
                    TransferArray,
                    "Unit",
                    partner,
                    "StandardTransfer"
                  );
                }
                if (partnerBusinessEventData.Standard.Forfeiture) {
                  let ForfeitureArray =
                    partnerBusinessEventData.Standard.Forfeiture;
                  self.calcSum(
                    ForfeitureArray,
                    "Unit",
                    partner,
                    "StandardForfeiture"
                  );
                }

                partner.StandardTotal =
                  partner.StandardIssuance +
                  partner.StandardTransfer +
                  partner.StandardForfeiture;
              }
              //Supplemental Calculation
              if (
                partnerBusinessEventData &&
                partnerBusinessEventData.Supplemental
              ) {
                if (partnerBusinessEventData.Supplemental.Issuance) {
                  let IssuanceArray =
                    partnerBusinessEventData.Supplemental.Issuance;
                  self.calcSum(
                    IssuanceArray,
                    "Unit",
                    partner,
                    "SupplementalIssuance"
                  );
                }
                if (partnerBusinessEventData.Supplemental.Transfer) {
                  let TransferArray =
                    partnerBusinessEventData.Supplemental.Transfer;
                  self.calcSum(
                    TransferArray,
                    "Unit",
                    partner,
                    "SupplementalTransfer"
                  );
                }
                if (partnerBusinessEventData.Supplemental.Forfeiture) {
                  let ForfeitureArray =
                    partnerBusinessEventData.Supplemental.Forfeiture;
                  self.calcSum(
                    ForfeitureArray,
                    "Unit",
                    partner,
                    "SupplementalForfeiture"
                  );
                }
                //partner.SupplementalTotal=partner.SupplementalIssuance + partner.SupplementalTransfer + partner.SupplementalForfeiture;
              }
              //Deal Calculation Added to Supplemental Sum
              if (partnerBusinessEventData && partnerBusinessEventData.Deal) {
                if (partnerBusinessEventData.Deal.Issuance) {
                  let IssuanceArray = partnerBusinessEventData.Deal.Issuance;
                  self.calcSum(
                    IssuanceArray,
                    "Unit",
                    partner,
                    "SupplementalIssuance"
                  );
                }
                if (partnerBusinessEventData.Deal.Transfer) {
                  let TransferArray = partnerBusinessEventData.Deal.Transfer;
                  self.calcSum(
                    TransferArray,
                    "Unit",
                    partner,
                    "SupplementalTransfer"
                  );
                }
                if (partnerBusinessEventData.Deal.Forfeiture) {
                  let ForfeitureArray =
                    partnerBusinessEventData.Deal.Forfeiture;
                  self.calcSum(
                    ForfeitureArray,
                    "Unit",
                    partner,
                    "SupplementalForfeiture"
                  );
                }
              }
              partner.SupplementalTotal =
                partner.SupplementalIssuance +
                partner.SupplementalTransfer +
                partner.SupplementalForfeiture;

              partner.TotalUnits =
                partner.StandardTotal + partner.SupplementalTotal;

              if (partner.Id != 1)
              {
                if (partner.Id == 9999)
                {
                  partner.TotalUnits = partnerResults2[0].VestedUnits;
                }
                /*else if (partner.Id == 1580)
                {
                  //partner.TotalUnits = partnerResults2[0].VestedUnits;
                  partner.TotalUnits = 0;
                  partnerResults2.forEach(function(obj) {
                    if(partner.UnitClass == obj.UnitClass && partner.VestingType == obj.VestingType)
                    {
                      partner.TotalUnits = partner.TotalUnits + obj.VestedUnits;
                    }
                  })
                }
                else if (partner.Id == 1634)
                {
                  //partner.TotalUnits = partnerResults2[0].VestedUnits;
                  partner.TotalUnits = 0;
                  partnerResults2.forEach(function(obj) {
                    if(partner.UnitClass == obj.UnitClass && partner.VestingType == obj.VestingType)
                    {
                      partner.TotalUnits = partner.TotalUnits + obj.VestedUnits;
                    }
                  })
                }
                  */
                else
                {
                  //partner.TotalUnits = partnerResults2[0].VestedUnits;
                  if (self.isRetired(partner.Id)) 
                  {
                    if (partner.Id == 2079)
                    { 
                      //partner.TotalUnits = 0;
                      var ptrTotOverride = false;
                      var ptrTotOverrideUnitAmts = 0;
                      partnerResults2.forEach(function(obj) {
                        if(partner.UnitClass == obj.UnitClass && partner.VestingType == obj.VestingType)
                        {
                          if (ptrTotOverride == false && obj.VestedUnits > 0)
                          {
                            ptrTotOverride = true;
                          }
                          ptrTotOverrideUnitAmts = ptrTotOverrideUnitAmts + obj.VestedUnits;
                        }
                      })

                      if (ptrTotOverride)
                      {
                        partner.TotalUnits = ptrTotOverrideUnitAmts;
                      }


                    }
                    else
                    {
                      partner.TotalUnits = 0;
                      partnerResults2.forEach(function(obj) {
                        if(partner.UnitClass == obj.UnitClass && partner.VestingType == obj.VestingType)
                        {
                          partner.TotalUnits = partner.TotalUnits + obj.VestedUnits;
                        }
                      })
                    }
                  }
                }
              }

              //Get Partner Ownership using Class
              partner.Ownership = self.getPartnerOwnership(partner.UnitClass);

              //Adjusted Total Units
              if(partner.Id == 1) {
              //Bonus units deduction on the fly  
              //partner.TotalUnits -= self.bonusUnits;
              partner.AdjustedTotalUnits =
                partner.Ownership * partner.TotalUnits;

              //console.log("Bonus Units",self.bonusUnits);
              } else {
              partner.AdjustedTotalUnits =
                partner.Ownership * partner.TotalUnits;

              }

              if (partner.Id != 1) {
                taxRunningTotal = taxRunningTotal + partner.AdjustedTotalUnits;
                self.StoreRunningTotalByClass(partner.UnitClass,partner.TotalUnits);
              }

              // if(partner.Id == 1) {
              //   FMVRunningTotal = FMVRunningTotal + partner.AdjustedTotalUnits - self.bonusUnits;
              // } else {

              // }
              FMVRunningTotal = FMVRunningTotal + partner.AdjustedTotalUnits;



              calculatedPartnerInfo.push(partner);
            });
          });
        });

        //Populate Partner Specific Details

        //var partnerArrayfromDB= response.children.Partner;
        const partnerConfig = item => item.PartnerId;
        var groupedByPartner = deepGroupBy(tranData, partnerConfig);

        //Calculation for % Tax Ownership and Patner Specific details
        calculatedPartnerInfo.forEach(function(partner) {
          let classRunningTotal=self.FetchRunningTotalByClass(partner.UnitClass);
  
          if (groupedByPartner[partner.Id] && groupedByPartner[partner.Id][0]) {
            partner.Name = groupedByPartner[partner.Id][0].PartnerFullName;
            partner.PartnerID=groupedByPartner[partner.Id][0].PartnerID;
            partner.HireDate = groupedByPartner[partner.Id][0].PartnerHireDate;
            partner.LeaveDate =
              groupedByPartner[partner.Id][0].PartnerLeaveDate;
            //partner.UnitClass=groupedByPartner[partner.Id][0].UnitClass;
            partner.PartnerTaxStatus =
              groupedByPartner[partner.Id][0].PartnerTaxStatus;
          }

        });

		var isNonTaxPartner = false;
		let filteredPartnerInfo = _.filter(calculatedPartnerInfo, function (obj) {
			return (!isNullOrUndefined(obj.PartnerTaxStatus) && obj.PartnerTaxStatus === "Non-Tax");
		});

		isNonTaxPartner = filteredPartnerInfo.length > 0;
		console.log("FMV Running Total",FMVRunningTotal,FMVRunningTotal+self.bonusUnits);
		 calculatedPartnerInfo.forEach(function(partner) {
          let classRunningTotal=self.FetchRunningTotalByClass(partner.UnitClass);
          //Bonus units deduction on the fly
          //var classBonusUnits = self.FetchRunningBonusUnitsByClass(partner.UnitClass);
          //console.log("classBonusUnits1",classBonusUnits);
          //classBonusUnits = isNullOrUndefined(classBonusUnits) ? 0 : classBonusUnits;
          //classRunningTotal = isNullOrUndefined(classRunningTotal) ? 0 : classRunningTotal;
          partner.TaxOwnership =
            partner.Id != 1 ? partner.AdjustedTotalUnits /classRunningTotal : 0;

          partner.TaxOwnership = partner.TaxOwnership ? partner.TaxOwnership : 0

		  if (!isNonTaxPartner) {
        //Bonus units deduction on the fly
        //partner.FMVOwnership = partner.AdjustedTotalUnits / (classRunningTotal - classBonusUnits);
        partner.FMVOwnership = partner.AdjustedTotalUnits / classRunningTotal;
        partner.FMVOwnership = partner.FMVOwnership ? partner.FMVOwnership : 0;
		  }
		  else{
        partner.FMVOwnership = partner.AdjustedTotalUnits / (FMVRunningTotal);
        partner.FMVOwnership = partner.FMVOwnership ? partner.FMVOwnership : 0;
		  }

      
        //call formEUMGridData passing in partner.Id, this.storeResponse.parent.InvestmentId
        //and this.selectedDate

        let EUMProgramTypeGridPdfData = self.formEUMGridData(partner.Id, self.ProgramInfo.parent.InvestmentId, self.selectedDate);

        if (!isNullOrUndefined(EUMProgramTypeGridPdfData))
        {
          if (EUMProgramTypeGridPdfData.length > 0)
          {
            if (EUMProgramTypeGridPdfData.length > 3)
            {
              if (partner.TotalUnits == EUMProgramTypeGridPdfData[1].Units)
              {
                partner.PreviousUnitDistribution = EUMProgramTypeGridPdfData[1].PreviousUnitDistribution;
                partner.ProgProjectedValue = EUMProgramTypeGridPdfData[1].ProgProjectedValue;
                //partner.ProjectedUnrealizedValue = EUMProgramTypeGridPdfData[1].ProjectedUnrealizedValue;
                partner.ProjectedUnrealizedValue = EUMProgramTypeGridPdfData[1].ProgProjectedValue * partner.FMVOwnership;
                partner.TotalPotentialPreTaxValuePercentChange = EUMProgramTypeGridPdfData[1].TotalPotentialPreTaxValuePercentChange;
                partner.ProgCurrentValue = EUMProgramTypeGridPdfData[1].ProgCurrentValue;
                //partner.CurrentValue = EUMProgramTypeGridPdfData[1].CurrentValue;
                partner.CurrentValue = EUMProgramTypeGridPdfData[1].ProgCurrentValue * partner.FMVOwnership;
                partner.TotalCurrentPreTaxValuePercentChange = EUMProgramTypeGridPdfData[1].TotalCurrentPreTaxValuePercentChange;
              }
              else if (partner.TotalUnits == EUMProgramTypeGridPdfData[2].Units)
              {
                partner.PreviousUnitDistribution = EUMProgramTypeGridPdfData[2].PreviousUnitDistribution;
                partner.ProgProjectedValue = EUMProgramTypeGridPdfData[2].ProgProjectedValue;
                //partner.ProjectedUnrealizedValue = EUMProgramTypeGridPdfData[2].ProjectedUnrealizedValue;
                partner.ProjectedUnrealizedValue = EUMProgramTypeGridPdfData[2].ProgProjectedValue * partner.FMVOwnership;
                partner.TotalPotentialPreTaxValuePercentChange = EUMProgramTypeGridPdfData[2].TotalPotentialPreTaxValuePercentChange;
                partner.ProgCurrentValue = EUMProgramTypeGridPdfData[2].ProgCurrentValue;
                //partner.CurrentValue = EUMProgramTypeGridPdfData[2].CurrentValue;
                partner.CurrentValue = EUMProgramTypeGridPdfData[2].ProgCurrentValue * partner.FMVOwnership;
                partner.TotalCurrentPreTaxValuePercentChange = EUMProgramTypeGridPdfData[2].TotalCurrentPreTaxValuePercentChange;
              }
              else
              {
                partner.PreviousUnitDistribution = EUMProgramTypeGridPdfData[1].PreviousUnitDistribution + EUMProgramTypeGridPdfData[2].PreviousUnitDistribution;
                partner.ProgProjectedValue = EUMProgramTypeGridPdfData[1].ProgProjectedValue;
                //partner.ProjectedUnrealizedValue = EUMProgramTypeGridPdfData[1].ProjectedUnrealizedValue + EUMProgramTypeGridPdfData[2].ProjectedUnrealizedValue;
                partner.ProjectedUnrealizedValue = (EUMProgramTypeGridPdfData[1].ProgProjectedValue * partner.FMVOwnership);// + (EUMProgramTypeGridPdfData[2].ProgProjectedValue * partner.FMVOwnership);
                //partner.TotalPotentialPreTaxValuePercentChange = EUMProgramTypeGridPdfData[2].TotalPotentialPreTaxValuePercentChange;
                partner.ProgCurrentValue = EUMProgramTypeGridPdfData[1].ProgCurrentValue + EUMProgramTypeGridPdfData[2].ProgCurrentValue;
                //partner.CurrentValue = EUMProgramTypeGridPdfData[1].CurrentValue + EUMProgramTypeGridPdfData[2].CurrentValue;
                partner.CurrentValue = EUMProgramTypeGridPdfData[1].ProgCurrentValue * partner.FMVOwnership;
                partner.TotalCurrentPreTaxValuePercentChange = EUMProgramTypeGridPdfData[1].TotalCurrentPreTaxValuePercentChange + EUMProgramTypeGridPdfData[2].TotalCurrentPreTaxValuePercentChange;
              }
            }
            else
            {
              if (partner.TotalUnits == EUMProgramTypeGridPdfData[1].Units)
              {
                partner.PreviousUnitDistribution = EUMProgramTypeGridPdfData[1].PreviousUnitDistribution;
                partner.ProgProjectedValue = EUMProgramTypeGridPdfData[1].ProgProjectedValue;
                //partner.ProjectedUnrealizedValue = EUMProgramTypeGridPdfData[1].ProjectedUnrealizedValue;
                partner.ProjectedUnrealizedValue = EUMProgramTypeGridPdfData[1].ProgProjectedValue * partner.FMVOwnership;
                partner.TotalPotentialPreTaxValuePercentChange = EUMProgramTypeGridPdfData[1].TotalPotentialPreTaxValuePercentChange;
                partner.ProgCurrentValue = EUMProgramTypeGridPdfData[1].ProgCurrentValue;
                //partner.CurrentValue = EUMProgramTypeGridPdfData[1].CurrentValue;
                partner.CurrentValue = EUMProgramTypeGridPdfData[1].ProgCurrentValue * partner.FMVOwnership;
                partner.TotalCurrentPreTaxValuePercentChange = EUMProgramTypeGridPdfData[1].TotalCurrentPreTaxValuePercentChange;
              }
              else
              {
                //partner.PreviousUnitDistribution = EUMProgramTypeGridPdfData[1].PreviousUnitDistribution;
                partner.ProgProjectedValue = EUMProgramTypeGridPdfData[1].ProgProjectedValue;
                //partner.ProjectedUnrealizedValue = EUMProgramTypeGridPdfData[1].ProjectedUnrealizedValue;
                partner.ProjectedUnrealizedValue = EUMProgramTypeGridPdfData[1].ProgProjectedValue * partner.FMVOwnership;
                partner.TotalPotentialPreTaxValuePercentChange = EUMProgramTypeGridPdfData[1].TotalPotentialPreTaxValuePercentChange;
                partner.ProgCurrentValue = EUMProgramTypeGridPdfData[1].ProgCurrentValue;
                //partner.CurrentValue = EUMProgramTypeGridPdfData[1].CurrentValue;
                //partner.CurrentValue = EUMProgramTypeGridPdfData[1].ProgCurrentValue * partner.FMVOwnership;
                partner.TotalCurrentPreTaxValuePercentChange = EUMProgramTypeGridPdfData[1].TotalCurrentPreTaxValuePercentChange;

              }
            }
          }

      }
    });

        this.ProgramPartners = calculatedPartnerInfo;
        console.log(calculatedPartnerInfo);
      } else {
        this.formDisplay = false;
      }
    },
    isRetired(partnerId) {
        let query = {
          batchQuery: true,
          filter: function(o) {
            return (
              o.Id == partnerId &&
              ( o.StartBuyout=="Completed" || o.StartBuyout == "Completed" ||  o.PartnerStatus === "Retired Employee" ||
                o.PartnerStatus === "Retired Family Member" )
            );
          }
        };
        let partnerResult=this.withFilter(BaseModelPartner.list,query)
          if(partnerResult && partnerResult.length>0) {
            return true;
          } else {
            return false;
          }
    },
    calcSum(sourceArray, sourecField, target, targetField) {
      sourceArray.forEach(function(obj) {
        target[targetField] = target[targetField] + obj[sourecField];
      });
    },
    calcBonusUnits(sourceArray) {
      let self = this;
      self.bonusUnits = 0;
      sourceArray.forEach(function(obj) {
        if(obj.UnitPool == "Treasury") {
          //console.log("Bonus Unit logs"+JSON.stringify(obj));
          //let Ownership = self.getPartnerOwnership(obj.UnitClass);
          var adjustedBonusUnits = obj.Unit;
          if(self.classRunningBonusUnits[obj.UnitClass]) {
            self.classRunningBonusUnits[obj.UnitClass]+= adjustedBonusUnits;
          } else {
            self.classRunningBonusUnits[obj.UnitClass] = adjustedBonusUnits;
          }
          self.bonusUnits += adjustedBonusUnits;
        }
      });
      return;
    },


    getProgramAutoCompleteData() {
      //Vuex
      // let filterQuery = {
      //       filter: "ProgramId eq " + self.ExceptionProgram.Child.Id
      //     };
      this.programAutoCompleteSource = this.withFilter(BaseModelProgram.list);
      // this._getItems(BaseModelProgram).then(response => {
      //   this.programAutoCompleteSource = response;
      // });
    },

    getPartnerOwnership(partnerUnitClass) {
      let UnitClassData = this.ProgramInfo.children.UnitClass;
      let UnitClass = _.find(UnitClassData, function(o) {
        return o.UnitClass == partnerUnitClass;
      });
      return UnitClass ? UnitClass.Ownership : 0;
    },
    StoreRunningTotalByClass(unitClass,value){
      if(this.classRunningTotalDict[unitClass]){
        this.classRunningTotalDict[unitClass]+=value;
      }else{
        this.classRunningTotalDict[unitClass]=value;
      }

    },
    FetchRunningTotalByClass(unitClass){
      return this.classRunningTotalDict[unitClass];
    },
    FetchRunningBonusUnitsByClass(unitClass){
      return this.classRunningBonusUnits[unitClass];
    },
    getPartnerProgramData(partnerId, programId){
      const self = this;
      //self.ProgramDetailGridData = [];
      
      let InvestorInfo = [];
      let partnerID = [];
      var taxYearQuarter = self.getTaxYearQuarter(self.selectedDate);   
      let InvestmentValuation = self.withFilter(self.BaseInvestmentValuation.list);
      partnerID.push({ PartnerId: partnerId });

      
       let query = {
          batchQuery: true,
          filter: function(o) {
            return (
              o.Id == partnerId
            );
          }
        };
        let objPtr=this.withFilter(BaseModelPartner.list,query)
              

      //var objPtr = this.withFilter(BaseModelPartner.list,x => x.Id == self.partnerId)
      //this.withFilter(BaseModelPartner.list,x => x.Id == self.partnerId)
      var ptrDate = self.selectedDate;

      /*
      if(objPtr[0].LeaveDate != null)
      {
        ptrDate = objPtr[0].LeaveDate;
      }
      */

      if(objPtr[0].LeaveDate != null)
      {
        var x = new Date(objPtr[0].LeaveDate);
        if (ptrDate > x)
        {
          ptrDate = x;
        }
      }

      let filteredBuyoutData = self.startBuyoutProcess(
        partnerID,
        ptrDate
        //self.selectedDate
      );

      let ClonedBuyout = _.clone(filteredBuyoutData);
      filteredBuyoutData = filteredBuyoutData.filter(x => x.ProgramId == programId);
      let groupedProgramId = _.groupBy(filteredBuyoutData, "ProgramId");
      _.forEach(groupedProgramId, function(ProgramVal, ProgramKey) {
        if (
          groupedProgramId &&
          groupedProgramId[ProgramKey] &&
          groupedProgramId[ProgramKey].length > 1
        ) {
          let groupedUnitClass = _.groupBy(
            groupedProgramId[ProgramKey],
            "UnitClass"
          );
          _.forEach(groupedUnitClass, function(ClassVal, ClassKey) {
            if (
              groupedUnitClass &&
              groupedUnitClass[ClassKey] &&
              groupedUnitClass[ClassKey].length > 1
            ) {
              let groupedUnitType = _.groupBy(
                groupedUnitClass[ClassKey],
                "UnitType"
              );
              _.forEach(groupedUnitType, function(TypeVal, TypeKey) {
                if (
                  groupedUnitType &&
                  groupedUnitType[TypeKey] &&
                  groupedUnitType[TypeKey].length > 1
                ) {
                  let groupedVestingType = _.groupBy(
                    groupedUnitType[TypeKey],
                    "VestingType"
                  );
                  _.forEach(groupedVestingType, function(VestVal, VestKey) {
                    if (
                      groupedVestingType &&
                      groupedVestingType[VestKey] &&
                      groupedVestingType[VestKey].length > 1
                    ) {
                      _.remove(filteredBuyoutData, function(x) {
                        return (
                          x.UnitClass ==
                            groupedVestingType[VestKey][0].UnitClass &&
                          x.UnitType ==
                            groupedVestingType[VestKey][0].UnitType &&
                          x.VestingType ==
                            groupedVestingType[VestKey][0].VestingType &&
                          x.PartnerId ==
                            groupedVestingType[VestKey][0].PartnerId &&
                          x.ProgramId ==
                            groupedVestingType[VestKey][0].ProgramId
                        );
                      });
                      groupedVestingType[VestKey][0].Unit = _.sumBy(
                        groupedVestingType[VestKey],
                        "Unit"
                      );
                      
                      //groupedVestingType[VestKey][0].VestedUnit = _.sumBy(
                       // groupedVestingType[VestKey],
                       // "VestedUnit"
                     // );
                      
                      filteredBuyoutData.push(groupedVestingType[VestKey][0]);
                    }
                  });
                }
              });
            }
          });
        }
      });

      //let vestingList =  self.withFilter(self.BaseModelVesting.list);
      let issuanceList = self.withFilter(self.BaseModelIssuance.list);
      let programList = self.withFilter(self.BaseModelProgram.list);
      programList = programList.filter(x => x.Id == programId);
      //let transferList = self.withFilter(self.BaseModelTransfer.list);

      //sum of awardunits
      var localProgramSumAwardedUnits = window.linq
        .from(filteredBuyoutData)
        .groupBy(
          "$.ProgramId",
          null,
          "{ProgramId: $, AmountPaidForProgram: $$.first(), SumofAwardedUnits: $$.sum('Number($.Unit)')}"
        )
        .toArray();
      // console.log(localProgramSumAwardedUnits);

      var localFirstAmountPaidForProgram = 0;

      //filteredBuyoutData = {program 1, unit 50}, {program 1, unit 50}, {program 2, unit 50}
      // localProgramSumAwardedUnits = {program 1, sum 100}, {program 2, sum 50}
      if (filteredBuyoutData.length && localProgramSumAwardedUnits.length) {
        for (var i = 0; i < filteredBuyoutData.length; i++) {
          var result = localProgramSumAwardedUnits.filter(function(obj) {
            return (
              obj.ProgramId.toString()
                .trim()
                .toLowerCase() ==
              filteredBuyoutData[i].ProgramId.toString()
                .trim()
                .toLowerCase()
            );
          })[0];

          if (result) {
            filteredBuyoutData[i].UnitPrice = 0;
            localFirstAmountPaidForProgram = 0;

            let ProgramDetailData = {};
            ProgramDetailData.Id = filteredBuyoutData[i].Id;
           
            var selectedProgram = programList.filter(x => x.Id == filteredBuyoutData[i].ProgramId);
            

            ProgramDetailData.ProgramName =
              !isNullOrUndefined(selectedProgram) && selectedProgram.length > 0
                ? selectedProgram[0].Title
                : "";

            self.PartnerName = ProgramDetailData.PartnerName =
              filteredBuyoutData[i].PartnerFullName;

            ProgramDetailData.ProgramId = filteredBuyoutData[i].ProgramId;
            ProgramDetailData.PartnerId = filteredBuyoutData[i].PartnerId;
            ProgramDetailData.PartnerLeaveDate =
              filteredBuyoutData[i].PartnerLeaveDate;
            ProgramDetailData.UnitPool = filteredBuyoutData[i].UnitPool;
            ProgramDetailData.UnitType = filteredBuyoutData[i].UnitType;
            ProgramDetailData.UnitClass = filteredBuyoutData[i].UnitClass;
            ProgramDetailData.UnitPrice = filteredBuyoutData[i].UnitPrice;
            ProgramDetailData.VestingType = filteredBuyoutData[i].VestingType;
            ProgramDetailData.AwardedUnits = filteredBuyoutData[i].Unit;
            ProgramDetailData.TotalUnits = filteredBuyoutData[i].Unit;
            ProgramDetailData.VestedUnits = !isNullOrUndefined(
              filteredBuyoutData[i].VestedUnit
            )
              ? filteredBuyoutData[i].VestedUnit
              : 0;

            ProgramDetailData.AmountPaidForProgram = localFirstAmountPaidForProgram;
            ProgramDetailData.SumofAwardedUnits = result.SumofAwardedUnits;
            ProgramDetailData.Forfeiture = 0;

            var selectedIssuance = issuanceList.filter(
              x =>
                x.ProgramId == ProgramDetailData.ProgramId &&
                x.ReceiverId == ProgramDetailData.PartnerId &&
                x.VestingType == ProgramDetailData.VestingType &&
                x.UnitClass == ProgramDetailData.UnitClass &&
                x.UnitType == ProgramDetailData.UnitType
            );

            /*
            var standardUnits = this.getUnitCalculationByProgram(
              ProgramDetailData.ProgramId,
              ProgramDetailData.PartnerId,
               ProgramDetailData.UnitClass,
                ProgramDetailData.VestingType
            );

            if (!isNullOrUndefined(standardUnits) && standardUnits.length > 0) {
              ProgramDetailData.Issuance = standardUnits[0].StandardIssuance;
              ProgramDetailData.Transfer = standardUnits[0].StandardTransfer;
              ProgramDetailData.Forfeiture =
                standardUnits[0].StandardForfeiture;
              ProgramDetailData.OwnershipExcludingTreasuryUnits =
                standardUnits[0].TaxOwnership;
              ProgramDetailData.OwnershipIncludingTreasuryUnits =
                standardUnits[0].FMVOwnership;
            } else {
              ProgramDetailData.Issuance = 0;
              ProgramDetailData.Transfer = 0;
              ProgramDetailData.OwnershipExcludingTreasuryUnits = 0;
              ProgramDetailData.OwnershipIncludingTreasuryUnits = 0;
            }
              */

            // Percentage overflow, infinity bug fix
            // from : filteredBuyoutData[i].VestedUnit / filteredBuyoutData[i].Unit
            // to : filteredBuyoutData[i].VestedUnit / standardUnits[0].StandardIssuance
            // Added : fix to two decimal to avoid 99.xx or 100.xx % 
            //console.log("calc vesting",selectedIssuance[0]);
            if(!isNullOrUndefined(selectedIssuance) &&
              selectedIssuance.length > 0) 
              {
            ProgramDetailData.VestPercentage = this.calculateVestPercentage(selectedIssuance[0]);
              } else {
                ProgramDetailData.VestPercentage = 0
              }
            

            if (
              !isNullOrUndefined(selectedIssuance) &&
              selectedIssuance.length > 0
            ) {
              ProgramDetailData.NextVestingDate = this.calcualateNextVestedDate(
                ProgramDetailData.VestPercentage * 100,
                new Date(selectedIssuance[0].VestStartDate)
              );
            } else {
              ProgramDetailData.NextVestingDate = "N/A";
            }

            let lclFMVSDistribution = this.getPartnerDistribution(
              filteredBuyoutData[i].PartnerId,
              filteredBuyoutData[i].ProgramId,
              self.selectedDate
            );
            //let filterQuery;
            // let invesmentId = _.filter(programList,function(obj){
            //   return obj.Id == filteredBuyoutData[i].ProgramId
            // })
            let investmentId = 0; 
            programList.forEach(item => {
              if(item.Id == filteredBuyoutData[i].ProgramId) {
                investmentId  = item.InvestmentInvestmentID;
                return;
              }
            });
            // let investmentId = programList.filter(x => {
            //   return (x.ProgramID == filteredBuyoutData[i].ProgramId)
            // });

            var taxYearQuarter = self.getTaxYearQuarter(self.selectedDate);
            if(filteredBuyoutData[i].ProgramId == self.ExceptionProgram.Child.Id) {
              investmentId = self.ExceptionProgram.Master.InvestmentInvestmentId; 
              // filterQuery = {
              //   filter : "InvestmentId eq" + self.ExceptionProgram.Master.InvestmentId +" and TaxYearQuarter eq  " +  taxYearQuarter
              // };
            } 
                 
            let lclFMVSValue = {
              "ProjectedValue" : 0,
              "CurrentValue" : 0
            };
            let pv = 0;
            let cv = 0;
            InvestmentValuation.forEach(obj => {
              //console.log("V",console.log(obj.InvestmentInvestmentID,obj.TaxYearQuarter,obj));
              if(obj.InvestmentInvestmentID == investmentId
                  && obj.TaxYearQuarter === taxYearQuarter) {
                  lclFMVSValue.ProjectedValue = obj.ProjectedValue;
                  lclFMVSValue.CurrentValue = obj.CurrentValue;                    
                  //console.log("Valuation Values",obj,lclFMVSValue);
                } 
            })
           

            console.log("lclFMVSValue",lclFMVSValue,ProgramDetailData.OwnershipIncludingTreasuryUnits);
          
            ProgramDetailData.CumulativeDistribution = lclFMVSDistribution;
            ProgramDetailData.PotentialValue =
               lclFMVSValue.ProjectedValue *ProgramDetailData.OwnershipIncludingTreasuryUnits;
            ProgramDetailData.LiquidationValue = lclFMVSValue.CurrentValue * ProgramDetailData.OwnershipIncludingTreasuryUnits;
            // ProgramDetailData.VestedPercent =
            //   filteredBuyoutData[i].VestedUnit / filteredBuyoutData[i].Unit;

            ProgramDetailData.UnitsToBeRetained = 0;

            //vested units + units to be retained
            ProgramDetailData.TotalUnitsToBeRetained =
              filteredBuyoutData[i].VestedUnit +
              ProgramDetailData.UnitsToBeRetained;

          
            //Unit Price x Total Units to be retained:
            ProgramDetailData.AmountPayable = isNaN(
              parseInt(
                filteredBuyoutData[i].UnitPrice *
                  ProgramDetailData.TotalUnitsToBeRetained
              )
            )
              ? 0
              : parseInt(
                  filteredBuyoutData[i].UnitPrice *
                    ProgramDetailData.TotalUnitsToBeRetained
                );

            //unit price x units to be forfeited
            ProgramDetailData.AmountReceivable = isNaN(
              parseInt(
                filteredBuyoutData[i].UnitPrice *
                  (filteredBuyoutData[i].Unit -
                    ProgramDetailData.TotalUnitsToBeRetained)
              )
            )
              ? 0
              : parseInt(
                  filteredBuyoutData[i].UnitPrice *
                    (filteredBuyoutData[i].Unit -
                      ProgramDetailData.TotalUnitsToBeRetained)
                );

            //Amount Paid For Program x (awarded units / (sum of awarded units for the program))
            ProgramDetailData.AmountPaid =
              localFirstAmountPaidForProgram *
              (filteredBuyoutData[i].Unit / result.SumofAwardedUnits);

            //max(0, amount paid - amount payable)
            ProgramDetailData.Buyout =
              ProgramDetailData.AmountPaid - ProgramDetailData.AmountPayable > 0
                ? ProgramDetailData.AmountPaid - ProgramDetailData.AmountPayable
                : 0;

            //max(0, amount payable - amount paid)
            ProgramDetailData.AmountOwedToPartnership =
              ProgramDetailData.AmountPayable - ProgramDetailData.AmountPaid > 0
                ? ProgramDetailData.AmountPayable - ProgramDetailData.AmountPaid
                : 0;

            //amount receivable - buyout
            ProgramDetailData.ContributionRelief =
              ProgramDetailData.AmountReceivable - ProgramDetailData.Buyout;

            //buyout - amount owed to partnership
            ProgramDetailData.NetPayout =
              ProgramDetailData.Buyout -
              ProgramDetailData.AmountOwedToPartnership;



            InvestorInfo.push(ProgramDetailData);
          }
        }
        // console.log(self.ProgramDetailGridData);
      }
      return InvestorInfo;
    },

    calcualateNextVestedDate(vestingpercentage, vestedDate) {
      let self = this;
      if(vestingpercentage < 25){
        return self._convertTimeZone(new Date(vestedDate.setMonth(vestedDate.getMonth()+12)));
      }
     else if(vestingpercentage >= 25 && vestingpercentage < 50) {
       return self._convertTimeZone(new Date(vestedDate.setMonth(vestedDate.getMonth()+24)));
     }
     else if(vestingpercentage >= 50 && vestingpercentage < 75) {
        return self._convertTimeZone(new Date(vestedDate.setMonth(vestedDate.getMonth()+36)));
     }
    else if(vestingpercentage >= 75 && vestingpercentage < 99) {
        return self._convertTimeZone(new Date(vestedDate.setMonth(vestedDate.getMonth()+48)));
    }
    else{
      return "N/A";
    }
    },

    calculateVestPercentage(element) {
          if (!this.isRetired(element.ReceiverId)) {
          if (element.VestingType=="Standard") {
            let vestStartDate = moment(element.VestStartDate);
            let dateToCompare = moment(this.selectedDate);
            let yearDiff=dateToCompare.diff(vestStartDate, 'years');
            switch (true) {
              case (yearDiff==1):
                return 0.25
                break;
              case (yearDiff==2):
                return 0.50
                break;
              case (yearDiff==3):
                return 0.75
                break;
              case (yearDiff>=4):
                return 1
                break;    
              default:
                return
                break;
            }
          }else if(element.VestingType=="Cliff" ){
            let cliffDate = moment(element.VestCliffDate).unix();
            if(cliffDate > 0 && moment(element.VestCliffDate)< moment(this.selectedDate)) {
              return 1;
            } else {
              return 0;
            }
          }
        }
        //This is for Accelerated VEsting for Retired Employee : Vest 100%
        else{
          if(element.VestingType=="Cliff") {
            let cliffDate = moment(element.VestCliffDate).unix();
            if(cliffDate < 0) {
              return 0;
            } else {
              return 1;
            }
          } else {
          return 1;
          }
        }      
    },
    isRetired(partnerId) {
        let query = {
          batchQuery: true,
          filter: function(o) {
            return (
              o.Id == partnerId &&
              ( o.StartBuyout=="Completed" || o.StartBuyout == "Completed" ||  o.PartnerStatus === "Retired Employee" ||
                o.PartnerStatus === "Retired Family Member" )
            );
          }
        };
        let partnerResult=this.withFilter(BaseModelPartner.list,query)
          if(partnerResult && partnerResult.length>0) {
            return true;
          } else {
            return false;
          }
    },
  
    //mitesh - end
  },
  mounted() {
    let self=this;
    $("#dtAsOfDate").kendoDatePicker({
    change: function() {
        self.selectedDate = this.value();
        self.getProgramInformation();
      }
    })
    this.getProgramAutoCompleteData();

    this.ShowAutoCompleteListOnFocus("SearchProgram");

    if (this.programId) {
      this.formDisplay = true;

      this.getProgramInformation();
    }
  }
};
</script>

<style scoped>
.k-widget.k-autocomplete.k-header.k-state-default {
  width: 250px;
  background-color: yellow;
}
</style>


